// 能够手动修改学校官网配置的学校id列表
export const expWebConfigList = ["49538854775951360","277074055142576128"]
// 编辑器显示上传文件按钮的学校列表
export const editorShowUploadList=["457463292223295488"]